const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.523,
    height: 604.724,
    viewBox: "0 0 119.201 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M166.489 155.007 107.554 33.803 47.288 154.43s1.69 16.848 62.058 17.413c51.456.483 57.143-16.836 57.143-16.836",
    style: {
      fill: "#55cef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75 161.55c-8 3.907-16.704 7.297-25.893 10.13-20.849-.718-33.742-3.538-41.707-6.698 19.177-3.512 37.267-9.133 52.939-16.581 15.007-7.133 28.208-15.089 38.439-24.16l7.768 15.976c-8.523 8.046-19.184 15.297-31.546 21.333",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.83 134.798c15.916-7.566 29.808-16.058 40.272-25.83l7.733 15.904c-8.806 8.744-20.098 16.606-33.345 23.076-16.751 8.178-36.56 14.107-57.536 17.347-13.07-4.942-13.666-10.865-13.666-10.865l1.32-2.642c20.024-3.478 38.927-9.245 55.221-16.99",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.999 133.672c-17.743 8.663-38.92 14.802-61.28 17.894l8.865-17.742c13.53-3.383 26.29-7.853 37.756-13.302 16.461-7.825 30.752-16.64 41.332-26.835l7.712 15.862c-8.947 9.164-20.61 17.394-34.385 24.123",
    style: {
      fill: "#55cef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.772 135.45 10.112-20.242c6.546-2.279 12.818-4.837 18.744-7.652 17.683-8.406 32.866-17.952 43.625-29.124l7.67 15.769c-9.204 10.122-21.675 19.198-36.635 26.505-12.965 6.33-27.764 11.311-43.516 14.743",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.736 62.97 7.634 15.695c-9.345 10.9-22.437 20.669-38.344 28.436-7.746 3.784-16.15 7.081-25.018 9.86l11.856-23.73c18.007-8.697 33.33-18.605 43.872-30.262",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.945 49.002c-6.738 7.799-15.4 15.012-25.636 21.32l18.245-36.519 7.39 15.199",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.243 47.558 7.616 15.666c-9.398 11.37-22.852 21.56-39.323 29.601-1.898.928-3.84 1.824-5.813 2.69L90.964 67.01c9.212-5.92 17.119-12.368 23.279-19.452",
    style: {
      fill: "#55cef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.562 170.766c-5.651-.553-10.51-1.29-14.689-2.142 4.179.852 9.037 1.59 14.689 2.14v.002m-14.7-2.144c-.017-.005-.035-.007-.051-.013.017.005.033.007.051.013m-.076-.017c-.01-.003-.019-.003-.028-.005.01.003.018.003.028.005",
    style: {
      fill: "#ace7fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.562 170.764c-5.652-.55-10.51-1.288-14.689-2.14-.004-.002-.008-.002-.011-.002-.018-.005-.034-.007-.051-.013-.008 0-.017-.003-.025-.005-.01-.002-.018-.002-.028-.005-4.771-.979-8.649-2.115-11.801-3.304 9.662-1.493 19.076-3.557 28.058-6.147l-1.453 11.618",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.957 165.295a49.655 49.655 0 0 1-2.6-1.067l6.773-15.524c9.06-1.914 17.813-4.34 26.097-7.24l-2.212 17.685c-8.982 2.59-18.396 4.653-28.058 6.146",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.13 148.704 7.573-17.353c7.234-2.16 14.176-4.668 20.726-7.495l-2.202 17.607c-8.284 2.901-17.036 5.327-26.097 7.241",
    style: {
      fill: "#ace7fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.703 131.351 81.4 111.42a165.41 165.41 0 0 0 9.626-4.318c1.631-.796 3.233-1.613 4.804-2.45l-2.401 19.205c-6.55 2.827-13.492 5.334-20.726 7.495",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4 111.419 91.617 88a134.612 134.612 0 0 0 6.822-4.21l-2.609 20.86c-1.57.837-3.173 1.654-4.804 2.45a165.41 165.41 0 0 1-9.626 4.318",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.617 88 8.825-20.226-2.003 16.016A134.612 134.612 0 0 1 91.617 88",
    style: {
      fill: "#ace7fc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.489 155.007-7.193-14.79 7.193 14.79m-9.592-19.722-4.703-9.674-.36-.739 5.063 10.413m-8.657-17.805-2.163-4.448-1.693-3.483-7.461-15.348-6.777-13.938-.78-1.598h.004l-1.71-3.513 20.58 42.328",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.438 171.853a291.51 291.51 0 0 1-9.992-.186v-.002l.41.015c9.19-2.833 17.893-6.223 25.894-10.13 12.362-6.036 23.023-13.286 31.546-21.332l7.193 14.79s-5.525 16.848-55.051 16.845m40.756-46.241-.36-.74.36.74m-6.117-12.58-1.693-3.483 1.693 3.483m-15.931-32.77-.78-1.598h.004l.776 1.599",
    style: {
      fill: "#4ba9cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.857 171.68-.41-.015c3.853-6.411 7.391-13.414 10.534-20.719a166.447 166.447 0 0 0 6.509-2.998c13.247-6.47 24.54-14.332 33.345-23.076l.36.74 4.702 9.673 2.399 4.932c-8.523 8.046-19.184 15.297-31.546 21.333-8 3.907-16.704 7.297-25.893 10.13",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.981 150.946a211.195 211.195 0 0 0 8.262-22.782c9.377-5.537 17.505-11.818 24.14-18.615l1.694 3.483 2.163 4.448 3.595 7.392c-8.806 8.744-20.098 16.606-33.345 23.076a166.447 166.447 0 0 1-6.509 2.998",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.243 128.164c2.374-7.923 4.251-15.864 5.55-23.508 4.106-3.33 7.828-6.825 11.13-10.455l7.46 15.348c-6.635 6.797-14.763 13.078-24.14 18.615",
    style: {
      fill: "#4ba9cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.792 104.656c1.472-8.636 2.209-16.893 2.096-24.307.504-.558.995-1.119 1.482-1.684l.776 1.598 6.777 13.938c-3.302 3.63-7.024 7.125-11.13 10.455",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.888 80.349a87.278 87.278 0 0 0-.23-5.197l1.712 3.513a92.712 92.712 0 0 1-1.482 1.684",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.4 11.854-4.266 14.177-13.895-.066 11.207 6.284-8.065 10.261 16.579-6.842 14.784 6.22-8.064-10.26 10.844-8.488-14.428 2.891-4.696-14.177",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.308 31.855-7.678-4.303 9.323.041 2.553-8.482 2.935 8.869 9.282-1.858-6.763 5.292 4.84 6.154-8.83-3.71-10.708 4.417 5.046-6.42",
    style: {
      fill: "#55cef8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.029386
    },
    transform: "translate(-47.288 -11.854)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat2);
export default __webpack_public_path__ + "static/media/birthday_hat_2.df2105e1fe9dc8f069c7adf96c437326.svg";
export { ForwardRef as ReactComponent };